module.exports = __webpack_public_path__ + "static/media/shareBg.57b61e47.png";